import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1287_5757",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 25,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				x: .5,
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1287_5757)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.4991 20C11.2158 20 10.9783 19.9042 10.7866 19.7125C10.5949 19.5208 10.4991 19.2833 10.4991 19V13L4.6991 5.6C4.4491 5.26667 4.4116 4.91667 4.5866 4.55C4.7616 4.18333 5.06577 4 5.4991 4H19.4991C19.9324 4 20.2366 4.18333 20.4116 4.55C20.5866 4.91667 20.5491 5.26667 20.2991 5.6L14.4991 13V19C14.4991 19.2833 14.4033 19.5208 14.2116 19.7125C14.0199 19.9042 13.7824 20 13.4991 20H11.4991Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgFilterIcon);
export default ForwardRef;
